import { HomeDefault } from './HomeDefault';
import { LogoLayoutNavbar } from './components/LogoLayoutNavbar';

HomeDefault.Navbar = LogoLayoutNavbar;

export default HomeDefault;
